var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideBarLogoExpanded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459,
    height: 80,
    viewBox: "0 0 459 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_46852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.5067 23.7886C96.5067 19.7541 95.4413 15.9144 93.3105 12.275C91.1797 8.63549 87.9888 5.68072 83.7273 3.41066C79.4762 1.1406 74.0596 0.00292969 67.4933 0.00292969H36.117C35.2204 0.00292969 34.4504 0.629699 34.2605 1.50402C34.2605 1.50402 29.8829 21.0813 28.3956 28.1022C28.1425 29.3031 29.0865 30.446 30.3154 30.3828C34.8038 30.1616 39.3976 28.9923 44.234 27.7651C45.5842 27.4228 46.9608 27.0752 48.3532 26.7433C49.0652 26.5748 49.619 26.0112 49.772 25.2949L51.2593 19.338C51.4491 18.4637 52.2192 17.8422 53.1105 17.8422H74.9141C76.0322 17.8422 76.8708 18.8692 76.6387 19.9647L74.6767 29.2557C74.4816 30.1879 73.5639 30.7673 72.6303 30.583H72.6198C67.372 29.5401 58.4586 29.8666 53.8278 30.7199C53.1158 30.8516 52.4091 30.9938 51.697 31.1413C51.697 31.1413 51.1802 31.2203 50.6527 31.373C41.0537 33.543 31.4599 37.1403 21.8609 34.6227C20.9115 34.3752 20.094 34.7175 19.8936 35.5181C18.8862 39.6316 17.9052 43.6766 16.8768 47.6269C16.4812 49.1543 17.1457 50.1129 18.844 50.8081C29.0971 54.9901 39.3712 51.2189 49.6348 48.7961C55.3626 47.4478 66.064 46.5103 71.7917 47.59C71.95 47.6321 72.1398 47.6795 72.3297 47.7269C72.8255 47.8534 73.1314 48.3484 73.0259 48.8435L70.3677 61.4474C70.1937 62.2638 69.4764 62.8484 68.6378 62.8484L4.56678 62.8221C3.67017 62.8221 2.90013 63.4488 2.71026 64.3232L-0.137805 77.7171C-0.385693 78.8969 0.510921 80.0029 1.71871 80.0029H61.1115C66.3804 80.0029 71.0323 79.1918 75.0776 77.5696C79.1176 75.9474 82.53 73.8248 85.3095 71.1913C87.6671 68.9581 89.5236 66.53 90.8949 63.9071C91.4276 63.0012 91.955 61.795 92.4771 60.2149C92.6301 59.7672 92.7672 59.3248 92.8885 58.8824C92.8885 58.8824 92.8885 58.8719 92.8885 58.8666C92.936 58.7033 92.9677 58.5506 93.0098 58.3926C93.0626 58.1819 93.1206 57.9765 93.1681 57.7658C94.6923 51.4402 93.2736 46.3365 90.3991 42.3178C89.9086 41.6331 89.9139 40.6955 90.4519 40.053C91.9708 38.2306 93.2155 36.266 94.1754 34.1592C95.7261 30.7726 96.5014 27.3122 96.5014 23.7833L96.5067 23.7886Z",
    fill: "url(#paint0_linear_184_46852)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.779 12.2748C167.649 8.63537 164.458 5.6806 160.196 3.41054C155.94 1.14047 150.529 0.00280762 143.962 0.00280762H112.586C111.689 0.00280762 110.919 0.629577 110.729 1.50389L94.5377 77.7169C94.2898 78.8968 95.1864 80.0028 96.3942 80.0028H113.303C114.2 80.0028 114.97 79.376 115.16 78.5017L127.728 19.3326C127.918 18.4583 128.688 17.8368 129.579 17.8368H151.383C152.496 17.8368 153.329 18.9218 153.097 20.012L150.333 33.0952C150.165 33.9063 149.447 34.4857 148.619 34.4857H130.75C129.073 34.4857 128.293 35.4495 128.34 37.7038C127.95 52.446 131.779 66.1401 140.423 78.6334C141.025 79.5551 141.399 80.0028 142.243 80.0028H161.483C162.754 80.0028 163.667 78.7756 163.297 77.5589C155.908 67.3568 149.985 60.4518 149.242 51.0503C149.252 49.8073 149.4 48.875 150.386 48.7328C162.944 46.9736 169.089 37.551 170.639 34.1644C172.19 30.7777 172.965 27.3173 172.965 23.7884C172.965 19.7539 171.9 15.9143 169.769 12.2748H169.779Z",
    fill: "url(#paint1_linear_184_46852)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.618 77.7169L185.81 1.50389C185.994 0.629577 186.77 0.00280762 187.666 0.00280762H247.618C248.82 0.00280762 249.722 1.10887 249.474 2.28867L246.484 16.4463C246.299 17.3206 245.524 17.9474 244.627 17.9474H204.654C203.763 17.9474 202.993 18.5689 202.803 19.4379L200.809 28.6235C200.551 29.8033 201.453 30.9199 202.661 30.9199H228.219C229.427 30.9199 230.329 32.0312 230.071 33.2111L227.207 46.5049C227.017 47.3792 226.247 48.0007 225.356 48.0007H198.273C197.381 48.0007 196.606 48.6222 196.421 49.4965L194.206 59.7618C193.953 60.9416 194.85 62.053 196.057 62.053H234.955C236.157 62.053 237.059 63.159 236.811 64.3388L233.821 78.4965C233.636 79.3708 232.861 79.9976 231.964 79.9976H171.474C170.267 79.9976 169.37 78.8915 169.618 77.7117V77.7169Z",
    fill: "url(#paint2_linear_184_46852)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.669 77.7169L255.861 1.50389C256.045 0.629577 256.821 0.00280762 257.717 0.00280762H314.726C315.929 0.00280762 316.831 1.10887 316.583 2.28867L313.592 16.4463C313.408 17.3206 312.632 17.9474 311.736 17.9474H274.705C273.814 17.9474 273.044 18.5689 272.854 19.4379L270.861 28.6235C270.602 29.8033 271.504 30.9199 272.712 30.9199H302.58C303.787 30.9199 304.689 32.0312 304.431 33.2111L301.567 46.5049C301.377 47.3792 300.607 48.0007 299.716 48.0007H268.318C267.427 48.0007 266.652 48.6222 266.467 49.4965L264.252 59.7618C263.999 60.9416 264.895 62.053 266.103 62.053H302.996C304.199 62.053 305.101 63.159 304.853 64.3388L301.862 78.4965C301.678 79.3708 300.902 79.9976 300.006 79.9976H241.52C240.312 79.9976 239.416 78.8915 239.664 77.7117L239.669 77.7169Z",
    fill: "url(#paint3_linear_184_46852)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.174 77.7169L400.366 1.50389C400.551 0.629577 401.326 0.00280762 402.223 0.00280762H456.157C457.359 0.00280762 458.261 1.10887 458.013 2.28867L455.023 16.4463C454.838 17.3206 454.063 17.9474 453.166 17.9474H419.211C418.32 17.9474 417.549 18.5689 417.36 19.4379L415.366 28.6235C415.108 29.8033 416.009 30.9199 417.217 30.9199H438.303C439.511 30.9199 440.413 32.0312 440.155 33.2111L437.291 46.5049C437.101 47.3792 436.331 48.0007 435.44 48.0007H412.829C411.938 48.0007 411.162 48.6222 410.978 49.4965L408.763 59.7618C408.51 60.9416 409.406 62.053 410.614 62.053H454.622C455.824 62.053 456.726 63.159 456.478 64.3388L453.488 78.4965C453.303 79.3708 452.528 79.9976 451.631 79.9976H386.031C384.823 79.9976 383.926 78.8915 384.174 77.7117V77.7169Z",
    fill: "url(#paint4_linear_184_46852)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.732 53.6522C347.767 51.5032 352.097 49.723 356.29 47.9954C368.78 42.8549 382.846 37.0612 388.885 20.5703C389.497 18.9007 389.945 17.1784 390.33 15.4456L393.225 2.30447C393.484 1.12467 392.587 0.00280762 391.374 0.00280762H325.088C324.191 0.00280762 323.416 0.629577 323.232 1.50389L320.241 15.6615C319.993 16.836 320.89 17.9474 322.098 17.9474H367.693C369.328 17.9474 370.146 19.8277 369.122 21.097C365.536 25.5318 358.695 28.5867 349.792 32.2525C345.22 34.138 340.489 36.0816 335.71 38.6255C324.118 44.7984 318.11 50.2181 315.03 54.853C313.269 57.5023 312.108 61.5052 311.507 64.6285L308.975 77.7169C308.728 78.8915 309.624 80.0028 310.832 80.0028H375.852C376.744 80.0028 377.514 79.3813 377.704 78.5123L380.778 64.3546C381.037 63.1748 380.135 62.0582 378.927 62.0582H336.981C335.162 62.0582 334.566 59.9567 335.832 58.6558C337.551 56.8861 340.473 55.3955 343.738 53.6574L343.732 53.6522Z",
    fill: "url(#paint5_linear_184_46852)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_184_46852",
    x1: 36.3458,
    y1: 98.0072,
    x2: 78.3861,
    y2: -0.453896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01277F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443215,
    stopColor: "#0131A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013ECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_184_46852",
    x1: 124.139,
    y1: 98.0071,
    x2: 172.107,
    y2: 6.83144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01277F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443215,
    stopColor: "#0131A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013ECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_184_46852",
    x1: 199.775,
    y1: 98.0007,
    x2: 247.23,
    y2: 6.10228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01277F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443215,
    stopColor: "#0131A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013ECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_184_46852",
    x1: 268.711,
    y1: 98.0007,
    x2: 317.183,
    y2: 7.58238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01277F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443215,
    stopColor: "#0131A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013ECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_184_46852",
    x1: 412.058,
    y1: 98.0007,
    x2: 461.609,
    y2: 9.26751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01277F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443215,
    stopColor: "#0131A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013ECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_184_46852",
    x1: 340.794,
    y1: 98.0071,
    x2: 386.762,
    y2: 4.09738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01277F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443215,
    stopColor: "#0131A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013ECB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_46852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 458.228,
    height: 80,
    fill: "white",
    transform: "translate(0.28418)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarLogoExpanded);
export default __webpack_public_path__ + "static/media/side-bar-logo-expanded.5a4c7c686d46ef963af28f8d7b487f18.svg";
export { ForwardRef as ReactComponent };